import { TPaymentPlanDTO } from '~/types/DTO/paymentPlan';

export interface PaymentPlanValues {
  monthlyAmortization: number | undefined;
  monthlyFee: number | undefined;
  monthlyPayment: number | undefined;
}

/**
 * Extracts monthly payment values from payment plan data.
 * Returns values from the first installment with a non-zero total amount,
 * searching from the end of the array to avoid campaign discount months.
 *
 * @param paymentPlanData - The payment plan response data
 * @returns Monthly amortization, fee, and total payment values
 */
export const getMonthlyPaymentValues = (
  paymentPlanData: TPaymentPlanDTO['getPaymentPlanRes'] | undefined
): PaymentPlanValues => {
  if (!paymentPlanData?.installments) {
    return {
      monthlyAmortization: undefined,
      monthlyFee: undefined,
      monthlyPayment: undefined,
    };
  }

  const firstNonZeroInstallment = [...paymentPlanData.installments]
    .reverse()
    .find((installment) => installment.totalAmount > 0);

  return {
    monthlyAmortization: firstNonZeroInstallment?.amortization,
    monthlyFee: firstNonZeroInstallment?.monthlyFee,
    monthlyPayment: firstNonZeroInstallment?.totalAmount,
  };
};
